<!-- MODAL Detalle Movimientos -->
<div mdbModal #detalleMov="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Detalle de movimientos para atender demanda
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="detalleMov.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col mb-1" style="display: flex; justify-content: flex-end;">
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-success"></mdb-icon><span> Atendido</span>
                        </div>
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-danger"></mdb-icon><span> Stock afectado</span>
                        </div>
                        <div class="leyenda">
                            <mdb-icon fas icon="circle" class="text-warning"></mdb-icon><span> Stock no afectado</span>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Formato</th>
                                <!-- <th scope="col" class="text-center">Código</th> -->
                                <th scope="col" class="text-center">Demanda</th>
                                <th scope="col" class="text-center">Stock actual</th>
                                <th scope="col" class="text-center">Stock tras movimiento</th>
                                <th scope="col" class="text-center">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let detalle of movimiento?.detalleAnalisisDemanda">
                                <td class="text-center">{{detalle.producto_formato}}</td>
                                <!-- <td class="text-center">{{detalle.producto_codigo}}</td> -->
                                <td class="text-center">{{detalle.cantidadAtendida | numerico}}</td>
                                <td class="text-center">{{detalle.stock_Actual | numerico}}</td>
                                <td class="text-center">{{detalle.stock_tras_movimiento | numerico}}</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" *ngIf="detalle.estadocodigo === 0" class="text-success">
                                    </mdb-icon>
                                    <mdb-icon fas icon="circle" *ngIf="detalle.estadocodigo === 1" class="text-danger">
                                    </mdb-icon>
                                    <mdb-icon fas icon="circle" *ngIf="detalle.estadocodigo === 2" class="text-warning">
                                    </mdb-icon>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td class="text-center">Caja</td>
                                <td class="text-center">cjx32</td>
                                <td class="text-center">0</td>
                                <td class="text-center">100</td>
                                <td class="text-center">100</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" class="text-warning"></mdb-icon>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">Caja</td>
                                <td class="text-center">cjx32</td>
                                <td class="text-center">0</td>
                                <td class="text-center">100</td>
                                <td class="text-center">100</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" class="text-success"></mdb-icon>
                                </td>
                            </tr> -->
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="detalleMov.hide()" mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
